import * as React from "react";
import * as moment from "moment";
import * as Modal from "react-modal";

export default class Filter extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      filter: {
        categories: null,
        subCategory: null,
        name: null,
        ages: null,
        followers: null,
        sex: null,
        cities: null,
        type: null,
      },
    };
  }
  editFilter = (e: any) => {
    const name = e.target.name;
    let value = e.target.value;
    let filter = this.state.filter;

    if (!value || value === "all" || value === "" || value.length === 0)
      value = null;

    if (
      name === "ages" ||
      name === "cities" ||
      name === "followers" ||
      name == "categories"
    ) {
      value = Array.from(
        e.target.selectedOptions,
        (option: any) => option.value
      );
    }

    if (name === "ages" && value.length === 5) {
      value = null; //all ages
    }

    filter[name] = value;
    this.setState({ filter });
  };
  public render() {
    return (
      <div style={{display: "inline-block"}}>
        <button
          onClick={() => {
            this.setState({
              exportModal: true,
            });
          }}
          style={{ width: "70px" }}
        >
          סינון
        </button>
        <Modal isOpen={this.state.exportModal} className="newUser-modal">
        <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                exportModal: false,
              });
            }}
          ></a>
          <div className="scroll">
            <select
              className="multiple"
              style={{height: "80px"}}
              onChange={this.editFilter.bind(this)}
              name="categories"
              multiple
            >
              {this.props.categories.map((category: any, i: number) => {
                return (
                  <option key={i} value={category.id}>
                    {category.title}
                  </option>
                );
              })}
            </select>
            <input
              onChange={this.editFilter.bind(this)}
              name="subCategory"
              placeholder="תת קטגוריה"
            />
            <input
              onChange={this.editFilter.bind(this)}
              name="name"
              placeholder="שם"
            />
            <select
              onChange={this.editFilter.bind(this)}
              className="multiple"
              name="ages"
              multiple
            >
              <option
                value={`${moment()
                  .subtract(18, "years")
                  .format("YYYY-DD-MM")}--${moment().format("YYYY-DD-MM")}`}
              >
                0-18
              </option>
              <option
                value={`${moment()
                  .subtract(25, "years")
                  .format("YYYY-DD-MM")}--${moment()
                  .subtract(18, "years")
                  .format("YYYY-DD-MM")}`}
              >
                18-25
              </option>
              <option
                value={`${moment()
                  .subtract(35, "years")
                  .format("YYYY-DD-MM")}--${moment()
                  .subtract(25, "years")
                  .format("YYYY-DD-MM")}`}
              >
                25-35
              </option>
              <option
                value={`${moment()
                  .subtract(50, "years")
                  .format("YYYY-DD-MM")}--${moment()
                  .subtract(35, "years")
                  .format("YYYY-DD-MM")}`}
              >
                35-50
              </option>
              <option
                value={`${moment()
                  .subtract(100, "years")
                  .format("YYYY-DD-MM")}--${moment()
                  .subtract(50, "years")
                  .format("YYYY-DD-MM")}`}
              >
                50+
              </option>
            </select>
            <select
              style={{height: "150px"}}
              className="multiple"
              onChange={this.editFilter.bind(this)}
              name="cities"
              multiple
            >
              {this.props.cities.map((city: string, i: number) => {
                return (
                  <option key={i} value={city}>
                    {city}
                  </option>
                );
              })}
            </select>
            <select
              onChange={this.editFilter.bind(this)}
              name="followers"
              className="multiple"
              multiple
            >
              <option value="0-20000">מיקרו</option>
              <option value="20000-50000">ביליס</option>
              <option value="50000-100000">אייליסט</option>
              <option value="100000-1000000000">סלבס</option>
            </select>
            <select
              onChange={this.editFilter.bind(this)}
              name="sex"
              defaultValue={"all"}
            >
              <option value="all">כל המינים</option>
              <option value="male">זכר</option>
              <option value="female">נקבה</option>
            </select>
            <select
              onChange={this.editFilter.bind(this)}
              name="type"
              defaultValue={"all"}
            >
              <option value="all">כל הסוגים</option>
              <option value="instagram">אינסטגרם</option>
              <option value="facebook">פייסבוק</option>
              <option disabled value="youtube">
                יוטיוב
              </option>
              <option disabled value="tiktok">
                טיקטוק
              </option>
            </select>
            <button
              onClick={() => {
                this.props.filter(this.state.filter);
              }}
              className="submit"
            >
              סינון
            </button>
          </div>
        </Modal>
      
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/Filter.tsx